import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { GET_CHATS_BY_FILTERS, type ChatAppType } from '../queries/chats';
import { MARK_CHAT_AS_READ } from '../queries/mutations';

export function useMarkChatAsRead(userUuid?: string, appType?: ChatAppType | null) {
  const [markChatAsReadMutation] = useMutation(MARK_CHAT_AS_READ, {
    refetchQueries: userUuid
      ? [
          {
            query: GET_CHATS_BY_FILTERS,
            variables: { userUuid, appType },
          },
        ]
      : [],
    awaitRefetchQueries: false, // Don't wait for refetch to complete
  });

  const markChatAsRead = useCallback(
    async (chatUuid: string) => {
      try {
        await markChatAsReadMutation({
          variables: { chatUuid },
        });
      } catch (error) {
        // Silently handle errors as this is not a critical operation
        // Error is intentionally ignored since marking as read is not critical
      }
    },
    [markChatAsReadMutation],
  );

  return markChatAsRead;
}
